function closeTagPanelObserver(element) {
  if (!element) return;
  // @ts-ignore
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const observer = new MutationObserver(function (mutations) {
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const panelOpens = mutation.target.classList.contains('panel-collapsed') || mutation.target.classList.contains('panel-open');
        if (panelOpens) {
          setTimeout(() => {
            const closeButton = mutation.target.querySelector('button');
            closeButton.click();
          }, 100);
          observer.disconnect();
        }
      }
    }
  });
  observer.observe(element, {
    attributes: true,
  });
}

function setTagPanelObserver(element, callback) {
  if (!element) return;
  // @ts-ignore
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const observer = new MutationObserver(function (mutations) {
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const panelOpens = mutation.target.classList.contains('panel-collapsed') || mutation.target.classList.contains('panel-open');
        callback(panelOpens, observer);
      }
    }
  });
  observer.observe(element, {
    attributes: true,
  });
}

export {
  closeTagPanelObserver,
  setTagPanelObserver,
};
